import { render, staticRenderFns } from "./BoxPickup.vue?vue&type=template&id=47580e90&scoped=true&"
import script from "./BoxPickup.vue?vue&type=script&lang=ts&"
export * from "./BoxPickup.vue?vue&type=script&lang=ts&"
import style0 from "./BoxPickup.vue?vue&type=style&index=0&id=47580e90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47580e90",
  null
  
)

export default component.exports